import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

const PaymentAssistCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState("processing");

    useEffect(() => {
        const paymentStatus = searchParams.get("status");
        const token = searchParams.get("token");

        if (!token) {
            toast.error("Invalid payment session");
            setTimeout(() => navigate("/"), 2000);
            return;
        }

        if (paymentStatus === "success") {
            setStatus("success");
            toast.success("Finance application approved! Your order has been confirmed.");

            // Clear cart
            localStorage.removeItem("cart");
            window.dispatchEvent(new Event("cartUpdated"));

            // Redirect to thank you page after 2 seconds
            setTimeout(() => {
                navigate("/thankyou");
            }, 2000);
        } else {
            setStatus("failed");
            toast.error("Finance application declined. Please try another payment method.");

            // Redirect back to checkout after 3 seconds
            setTimeout(() => {
                navigate("/checkout");
            }, 3000);
        }
    }, [searchParams, navigate]);

    return (
        <section className="inner-banner">
            <div className="container-fluid web-padding">
                <div className="row">
                    <div className="col-md-12">
                        <div className="thankyoubanner text-center">
                            {status === "processing" && (
                                <>
                                    <div className="spinner-border text-primary mb-4" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <h1>Processing Payment...</h1>
                                    <p>Please wait while we confirm your finance application.</p>
                                </>
                            )}

                            {status === "success" && (
                                <>
                                    <div className="success-icon mb-4">
                                        <i className="fas fa-check-circle text-success" style={{ fontSize: "80px" }}></i>
                                    </div>
                                    <h1 className="text-success">Finance Approved!</h1>
                                    <p>Your order has been confirmed successfully.</p>
                                    <p>You'll be redirected to the thank you page shortly...</p>
                                </>
                            )}

                            {status === "failed" && (
                                <>
                                    <div className="error-icon mb-4">
                                        <i className="fas fa-times-circle text-danger" style={{ fontSize: "80px" }}></i>
                                    </div>
                                    <h1 className="text-danger">Finance Application Declined</h1>
                                    <p>Unfortunately, your finance application was not approved.</p>
                                    <p>You'll be redirected back to checkout to try another payment method...</p>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <h2>Payment Assist</h2>
        </section>
    );
};

export default PaymentAssistCallback;
